<template>
  <!-- 用户设置 -->
  <div class="user-edit">
    <Navbar :title="'设置'"></Navbar>
    <div class="content">
      <router-link to="/identity" class="item">
        <div class="left">
          <i class="iconfont iconshenfen-tianchong"></i>
          <span class="title">设置身份</span>
        </div>
        <i class="iconfont iconjiantou"></i>
      </router-link>
      <router-link to="/editUserinfo" class="item">
        <div class="left">
          <i class="iconfont iconshezhi"></i>
          <span class="title">完善个人信息</span>
        </div>
        <i class="iconfont iconjiantou"></i>
      </router-link>
      <router-link to="/editShopinfo" class="item" v-if="userInfo.identity == 1">
        <div class="left">
          <i class="iconfont icondianpushezhi"></i>
          <span class="title">完善厂商信息</span>
        </div>
        <i class="iconfont iconjiantou"></i>
      </router-link>
      <router-link to="/editShifuinfo" class="item" v-if="userInfo.identity == 2">
        <div class="left">
          <i class="iconfont iconweixiu1"></i>
          <span class="title">完善维修信息</span>
        </div>
        <i class="iconfont iconjiantou"></i>
      </router-link>
      <router-link to="/editPeijianinfo" class="item" v-if="userInfo.identity == 3">
        <div class="left">
          <i class="iconfont icondianpushezhi"></i>
          <span class="title">完善厂商信息</span>
        </div>
        <i class="iconfont iconjiantou"></i>
      </router-link>
      <router-link to="/EditPassword" class="item">
        <div class="left">
          <i class="iconfont iconxiugaimima"></i>
          <span class="title">修改密码</span>
        </div>
        <i class="iconfont iconjiantou"></i>
      </router-link>
      <router-link to="/account" class="item">
        <div class="left">
          <i class="iconfont iconqiehuanzhanghao"></i>
          <span class="title">切换账号</span>
        </div>
        <i class="iconfont iconjiantou"></i>
      </router-link>
      <van-button class="logout" type="danger" @click="onLogout" block>退出登录</van-button>
    </div>
  </div>
</template>

<script>
import Tabber from "../components/Tabber";
import Navbar from "../components/Navbar";
import {
  indexOp,
  updateOp,
  deleteOp,
  addOp,
  showOp,
  uploadImg,
  uploadFile,
} from "../api/index";
import base from "../api/base";
export default {
  props: {},
  data() {
    return {
      userInfo:""
    };
  },
  computed: {},
  created() {
    this.userInfo = this.$cookies.get("userInfo");
  },
  mounted() {},
  watch: {},
  methods: {
    onLogout(){
      var _this = this;
      _this.$dialog.confirm({
        title: '提示',
        message: '是否要退出该账号？',
      })
        .then(() => {
          // on confirm
          _this.$cookies.remove("Authorization");
          _this.$cookies.remove("userInfo");
          _this.$cookies.remove("identity");
          _this.$router.push("/login")
        })
        .catch(() => {
          // on cancel
        });
    },
  },
  components: { Navbar, Tabber },
};
</script>

<style scoped >
</style>
